let mapper_options = {
  name: 'widget',
  endpoint: 'widgets',
  recordClass: require('./record')
}

module.exports = (store) => {
  store.defineMapper('widget', mapper_options)
}
